export default {
  modelName: 'idtf_review',
  versionModelName: 'act_version',
  label: '我的覆核鑑別作業',
};
